import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostListener,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import {IrbEditor} from "@irb/irb-editors/irb-editors.base";
import {IEvent, IrbAppEvents, IrbEditorsEvents, IrbModelsEvents,IrbSettingsEvents} from "@irb-common/events";
import {IModelDetailRequest, IModelDetailsResponse} from '../irb-editors.model';
import {HttpErrorResponse} from '@angular/common/http';
import {EditorModelService} from '@irb/irb-editors/editor-model/editor-model.service';
import {IAlertDialogData,IApplyFilterOnLanding} from '@irb/app.model';
import {ModelMarketCenterService} from "@irb/irb-models/model-market-center/model-market-center.service";
import {AnalyticsService} from "@irb-common/analytics/analytics.service";
import {ModelsService, ICreateModel} from "@irb/irb-models/models-new/models.service";
import {IGlobalSettings} from "@irb/irb-settings/irb-settings.model";
import {IrbSettingsService} from "@irb/irb-settings/irb-settings.service";
import {Router} from "@angular/router";
@Component({ standalone: false,
  selector: 'irb-editor-model',
  templateUrl: './editor-model.component.html',
  styleUrls: ['./editor-model.component.scss', '../../irb-common/styles/dialog.scss', '../editor-sidebar/editor-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None
})
export class EditorModelComponent extends IrbEditor {
  @ViewChild('body') body: ElementRef;

  modelEventData: any;
  showInLineeditFlag: boolean;
  showInLineEditDescFlag: boolean;
  tooltipMessage: any;
  tooltipDescMessage = 'Please provide valid model description.';
  defaultExpandedPanels: Array<string> = ["SECURITYMODELHISTORY", "SECURITYALLOCATIONS", "ALLOCATIONCHART"];
  private modelStatus: string;
  historyData: any;
  isRebalanceBtnAnabled: boolean = true;
  showBack: boolean = false;
  modelRalations: any;
  createModifyData: any = {};
  securityAllocationState: any = true;
  securityAllocationChartState: any = true;
  securityAllocationHistoryState: any = false;
  isSubscribeModel: boolean = false;
  roles: any;
  eventPrevNextObject: any = null;
  isUiTest = false;
  slideOutTitle: string = 'Edit a Security Model';
  showAllocationCustomView: boolean = false;
  updateStatusCount = 0;
  progressTimer: any;
  redirectURL: string;
  window: any;
  globalSettingsData: IGlobalSettings;
  historyPanelOpened: boolean;
  isCopyModelEnabled: boolean;
  isPendingReviewBannerEnabled: boolean = true;
  isUserAutoRebalanceEnabled: boolean;
  isMMCAutomationEnabledFlag: false;
  ENABLE_SEC_GRID_CHART: boolean;
  pfCount: number = 0;
  modelUpdated: boolean;
  ENABLE_SYNTAX_SSO: boolean;
  //isAutomationEnabledUser: false;

  constructor(private cdr: ChangeDetectorRef,
              private editorModelService: EditorModelService,
              private mmc: ModelMarketCenterService,
              public ats: AnalyticsService,
              private iss: IrbSettingsService,
              private readonly router: Router,
              private mos: ModelsService
            ) {
    super();
    this.identifier = 'modelId';
    const userDetails = this.as.getItem("IRB_APP_CONFIG");
    this.isUserAutoRebalanceEnabled = userDetails?.isAutomationEnabled;
    this.redirectURL = userDetails?.veoRedirectUrl;
    this.window = window;
    this.historyPanelOpened = this.defaultExpandedPanels.includes("SECURITYMODELHISTORY");
    this.isCopyModelEnabled = userDetails?.featureFlags?.isCopyModelEnabled || false;
    this.ENABLE_SEC_GRID_CHART = userDetails?.featureFlags?.ENABLE_SEC_GRID_CHART || false;
    this.ENABLE_SYNTAX_SSO = userDetails?.featureFlags?.ENABLE_SYNTAX_SSO || false;
  }

  get(event: IEvent) {
    this.isMMCAutomationEnabledFlag = this.as.getItem('IRB_APP_CONFIG')?.featureFlags.MMCAutomationEnabled || false;
    this.historyData = null;
    this.roles = this.mmc.getRoles();
    super.get(event);
    this.ats.trackModelsEditSecurityModelEvent();
    this.ies.loadExpansionState(this.defaultExpandedPanels.length, "editor-model", this.defaultExpandedPanels);

    this.modelEventData = event.data;
    if (typeof this.modelEventData.rowIndex !== 'undefined') {
      this.eventPrevNextObject = {
        type: 'IRBMODELSEVENTS.SHOW_EDIT_MODEL',
        data: {
          fullscreen: this.modelEventData.fullscreen,
          rowIndex:this.modelEventData.rowIndex,
          isDraft:this.modelEventData.isDraft,
          approvedModelId: this.modelEventData.approvedModelId,
          slot: this.modelEventData.slot || null
        }
      }
    }
    if(this.modelEventData.openFromBlended === true){
      this.showBack = true;
    }else{
      this.showBack = false;
    }

    const modelDetailsReq = {
      modelId: event.data.modelId,
      type: event.data.type,
      isDraft: event.data.isDraft,
      approvedModelId: event.data.approvedModelId
    };
    this.isSubscribeModel = event.data.modelMarketId ? true : false;
    this.setSlideOutTitle();
    this.iss.getGlobalSettings().subscribe((data: any) => {
      this.globalSettingsData = data;
      this.editorModelService.clearAll();
      this.ies.getModelDetailsForEditModel(modelDetailsReq).subscribe((data: any) => {
        if (data && data.approvedDTO) {
          this.isSubscribeModel = data.approvedDTO.modelMarketId ? true : false;
          this.setSlideOutTitle();
          this.modelStatus = data.approvedDTO.status;
          this.isRebalanceBtnAnabled = this.modelStatus === 'complete';
          this.load(data.approvedDTO as IModelDetailsResponse);
        }
      },
      () => {
       this.as.fireEvent(IrbEditorsEvents.HIDE_WAIT, { "slot": this.slot });
      });
    },
    () => {
      this.as.fireEvent(IrbEditorsEvents.HIDE_WAIT, { "slot": this.slot });
    });


    this.securityAllocationState = this.ies.getDefaultExpansionState('SECURITYALLOCATIONS');
    this.securityAllocationChartState = this.ies.getDefaultExpansionState('ALLOCATIONCHART');
    this.ies.updateExpansionState('SECURITYMODELHISTORY','closed');
    this.historyPanelOpened = false;
    if (event.data.openHistory) {
      this.securityAllocationState = false;
      this.securityAllocationChartState = false;
      this.securityAllocationHistoryState = true;
      event.data.openHistory = null;
    }
  }

  private setSlideOutTitle() {
    if (this.isSubscribeModel) {
      this.slideOutTitle = 'Edit a Subscribed Model';
    } else {
      this.slideOutTitle = this.modelEventData.isDraft ? 'Create a Security Model' : 'Edit a Security Model'
    }
  }

  load(data: IModelDetailsResponse) {
    if (data.securityModelAllocationList) {
      data.noOfSecurities = data.securityModelAllocationList.length;
      this.editorModelService.createCustCatMap(data.securityModelAllocationList);
      if (data.noOfSecurities !== 0) {
        data.securityModelAllocationList.forEach((cat) => {
          cat.categoryColor = this.editorModelService.getColorByCategory(cat.customCategoryName);
        });
      }
    }
    this.createModifyData = {
      createdDate: data.createdDate,
      createdBy: data.createdBy,
      modifiedDate: data.modifiedDate,
      modifiedBy: data.modifiedBy,
      lastModifiedHistoryDate: data.lastModifiedHistoryDate,
      historyLastModifiedBy: data.historyLastModifiedBy,
      modelName: data.securityModelName
    };

    this.pfCount = data.pfCount;
    if (data.modelType) {
      data.modelType = data.modelType === 'Base' ? 'Security' : data.modelType;
    }
    this.showInLineeditFlag = false;
    this.showInLineEditDescFlag = false;
    this.tooltipMessage = '';
    this.isValid = this.validMinMaxTarget();

    super.load(data);
    if (this.showUnsavedChangesWarning) {
      this.closeWithoutSave();
    }

    this.setEditorModelHeight();
    if (!this.isUiTest) {
      this.getModelRelations();
    }

    if(this.modelEventData.copyOnLoad) {
      this.copyModelProceed();
    }
  }

  saveInlineEdit(securityModelName: any) {
    if (securityModelName.trim() === '') {
      this.closeInlineEdit();
      const originalData = super.getOriginalData();
      this.data.securityModelName = originalData?.securityModelName;
      return;
    }
    this.ies.validateSecurityModelName(securityModelName, 'Security').subscribe((data: any) => {
      if (!data.data) {
        this.tooltipMessage = '';
        this.data.securityModelName = securityModelName;
        this.showInLineeditFlag = false;
        this.onInputChange();
      } else {
        this.tooltipMessage = 'This Security Model name already exists. Please enter a different name.';
      }
    });
  }

  onInputChange() {
    super.onInputChange();
    this.editorModelService.createCustCatMap(this.data.securityModelAllocationList);
    this.isValid = this.validMinMaxTarget();
    this.cdr.detectChanges();
  }

  saveInlineDescEdit(securityModelDescription: any) {
    this.data.securityModelDescription = securityModelDescription;
    this.showInLineEditDescFlag = false;
    this.onInputChange();
  }

  showInlineEdit() {
    this.showInLineeditFlag = true;
    this.cdr.detectChanges();
  }

  showInlineDescEdit() {
    this.showInLineEditDescFlag = true;
    this.cdr.detectChanges();
  }

  closeInlineEdit() {
    this.tooltipMessage = '';
    this.showInLineeditFlag = false;
  }

  closeInlineDescEdit() {
    this.showInLineEditDescFlag = false;
  }

  onTextChange() {
    this.tooltipMessage = '';
  }

  getModelRelations() {
    if (this.data) {
      const modelDetail: IModelDetailRequest = {
        modelId: this.data.securityModelId,
        type: 'Base',
      };
      if (this.ies && this.ies.getModelAssociationDetails) {
        this.ies.getModelAssociationDetails(modelDetail).subscribe((res: any) => {
          this.modelRalations = res;
          this.isRebalanceBtnAnabled = this.modelStatus === 'complete' && res.hasValidPortfolioRelation;
        });
      }
    }
  }
  openInModelMarketCenter() {
    let modelData = JSON.parse(JSON.stringify(this.modelEventData));
    const eventData: any = {
      type: 'editMMCAdvisorModel',
      data: modelData,
      rowCount: 1,
      rowIndex: 0,
      sortField: null,
      filter: null,
      readOnlyView: true,
      slot:"B"
    };
    this.as.fireEvent(IrbModelsEvents.SHOW_EDIT_MMC_ADVISOR_MODEL, eventData);
  }
  onOpenHistoryPanel() {
    this.ies.updateExpansionState('SECURITYMODELHISTORY','opened');
    this.historyPanelOpened = true;
    if (this.modelEventData && !this.historyData) {
      this.ies.getSecurityModelHistory(this.modelEventData.modelId, 'view').subscribe((historyData: any) => {
        this.historyData = historyData;
      });
    }
  }
  onCloseHistoryPanel() {
    this.ies.updateExpansionState('SECURITYMODELHISTORY','closed');
        this.historyPanelOpened = false;
  }

  @HostListener("window:resize")
  onResize() {
    this.setEditorModelHeight();
  }

  onAutoRebalanceEnabledChange() {
    if (this.data.allowAutoRebalOnModelUpdate === 'ALLOWED') {
        this.data.allowAutoRebalOnModelUpdate = 'NOT_ALLOWED';
    } else {
        this.data.allowAutoRebalOnModelUpdate = 'ALLOWED';
    }
    this.onInputChange();
  }

  onResumeAutomatedRebalancing() {
    this.data.allowAutoRebalOnModelUpdate = 'ALLOWED';
    this.onInputChange();
  }

  onDismissPendingReviewStatus() {
    this.data.allowAutoRebalOnModelUpdate = 'NOT_ALLOWED';
    this.onInputChange();
  }
  onClosePendingReviewBanner() {
    this.isPendingReviewBannerEnabled = false;
  }
  private setEditorModelHeight() {
    if (this.body) {
      const rect = this.body.nativeElement.getBoundingClientRect();
      let h = (window.innerHeight - rect.top - 10);

      h = (h < 200) ? 200 : h;
      this.bodyHeight = h + 'px';
    }
  }

  processEvent(event: IEvent) {
    super.processEvent(event);

    this.cdr.detectChanges();
  }

  save() {
    this.ats.trackClickEvent("lc_editsecsave");

    if (this.data && this.data.securityModelAllocationList && this.data.securityModelAllocationList.length !== 0) {
      this.data.securityModelAllocationList.forEach((sec: any) => {
        delete sec.categoryColor;
      });
    }

    const modelDetail: IModelDetailRequest = {
      modelId: this.data.securityModelId,
      type: 'Base',
    };
    this.as.fireEvent(IrbEditorsEvents.SAVE_START, { "slot": this.slot });
    this.ies.getModelAssociationDetails(modelDetail).subscribe((res: any) => {
      const targetTotal = this.data && this.data.securityModelAllocationList?.length === 0 ? 0 : this.editorModelService.getTotalTargetPercent();
      if (res.modelAssociated && Number(targetTotal) !== 100) {
        this.as.fireEvent(IrbEditorsEvents.HIDE_WAIT, { "slot": this.slot });
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
          severity: 'error',
          summary: 'Targets must equal 100%',
          detail: 'Security targets do not add up to 100%. This model is assigned to a portfolio or blended model and cannot be saved.'
        });
      } else {
        if (!this.validMinMaxTarget()) {
          this.as.fireEvent(IrbEditorsEvents.HIDE_WAIT, { "slot": this.slot });
          return;
        }

        //is copy model
        if(this.data.securityModelId == -1) {
          this.checkSecurityModelName(() => {
            this.completeSave();
          }, () => {
            this.as.fireEvent(IrbEditorsEvents.HIDE_WAIT, { "slot": this.slot });
          });
        } else {
          this.completeSave();
        }
      }
    });
  }

  completeSave() {
    this.modelUpdated = true;
    this.ies.saveModelDetailsAsync(this.data).subscribe((responseData: any) => {// saveModelDetailsAsync
      this.updateStatusCount = 0;
      this.progressTimer && clearTimeout(this.progressTimer);
      this.updateStatusCount = 0;
      if (responseData.responseUtilityMap) {
        this.actionStatusCheckIntervalStart(responseData.responseUtilityMap.statusId);
      }
    }, (err: HttpErrorResponse) => {
      this.as.fireEvent(IrbEditorsEvents.SAVE_ERROR, { 'slot': this.slot });
      let m = err.message ? err.message : 'Editor Model save failed.';
      m += ' modelId=' + this.data.securityModelId;
      if (!this.isUiTest) {
        throw new Error(m);
      }
    });
  }


  saveEditModelProceed(response: any) {
      //is copy model
      if(this.data.securityModelId == -1) {
        this.data.securityModelId = response.responseData.modelId;
        this.data.versionId = response.responseData.modifiedVersion;
        this.data.modifiedDate = response.responseData.modifiedDate;
        this.data.modifiedBy = response.responseData.modifiedBy;
      }

    if (response.responseStatus === 'SUCCESS') {
      const modelDetailsReq = {
        modelId: this.data.securityModelId,
        type: 'Base',
        isDraft: this.data.isDraft,
        approvedModelId: this.data.approvedModelId
      } as IModelDetailRequest;
      if (this.modelEventData?.parentObj) {
        this.modelEventData.parentObj.reloadAfterModelClosed = true;
      }
      this.ies.getModelDetailsForEditModel(modelDetailsReq).subscribe((modelDetailsData: any) => {
        if (modelDetailsData && modelDetailsData.approvedDTO) {
          this.modelStatus = modelDetailsData.approvedDTO.status;
          this.ies.getSecurityModelHistory(this.data.securityModelId, 'view').subscribe((historyData: any) => {
            this.historyData = historyData;
          });

          let toastDetail = this.modelEventData.isDraft ? '1 model was created.' : 'Model updated.';
          let totalAllocation: any = this.editorModelService.getTotalTargetPercent();
          if (totalAllocation !== 100) {
            toastDetail = 'To use this model, allocations must equal 100%.';
            this.as.fireEvent(IrbEditorsEvents.WARN_SUCCESS, {
              'hasPendingFunction': this.hasPendingFunction,
              'data': toastDetail,
              'summary': 'Incomplete Security Model',
              'slot': this.slot,
              removeOnClose: true
            });
          } else {
            let toastSummary = this.modelEventData.isDraft ? 'Create Security Model' : null;

            this.as.fireEvent(IrbEditorsEvents.SAVE_SUCCESS, {
              'hasPendingFunction': this.hasPendingFunction,
              'data': (this.modelEventData.isCopy) ? "A copy of your model has been created" : toastDetail,
              'summary': toastSummary,
              'slot': this.slot,
              removeOnClose: true
            });
          }

          this.modelEventData.isDraft = false;
          this.modelEventData.isCopy = false;
          this.setSlideOutTitle();
          this.load(modelDetailsData.approvedDTO as IModelDetailsResponse);
          this.cdr.detectChanges();
          this.as.fireEvent(IrbAppEvents.GRID_REFRESH, {'slot': this.slot});
          if(this.modelEventData.openFromBlended === true){
            this.as.fireEvent(IrbModelsEvents.MODEL_ALLOCATION_REFRESH);
          }
        }
      });
      this.as.fireEvent(IrbEditorsEvents.HIDE_WAIT, { "slot": this.slot });
    } else if (response.responseStatus === "BUSINESS_ERR_MSG" || response.responseStatus === "EXCEPTION") {
      this.as.fireEvent(IrbEditorsEvents.HIDE_WAIT, { "slot": this.slot });
      this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
        severity: "error",
        summary: "Please refresh Page",
        detail: "Exception occurred",
      });
      if (!this.isUiTest) {
        throw new Error('Editor Model save failed. modelId=' + this.data.securityModelId);
      }
    } else if (response.responseStatus === 'STALEDATAEXCEPTION') {
      this.as.fireEvent(IrbEditorsEvents.HIDE_WAIT, { "slot": this.slot });
      this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
        dTitle: 'Refresh Required',
        dProceedBtnLabel: 'Refresh',
        msg: "You are attempting to edit a model that was just modified by someone else. To see the updated model, you need to refresh the page.",
        onProceed: () => {this.refreshEditModel()}
      } as IAlertDialogData);
    }
  }

  refreshEditModel() {
    const modelDetailsReq = {
      modelId: this.data.securityModelId,
      type: 'Base',
      isDraft: this.data.isDraft,
      approvedModelId: this.data.approvedModelId
    } as IModelDetailRequest;

    this.ies.getModelDetailsForEditModel(modelDetailsReq).subscribe((modelDetailsData: any) => {
      if (modelDetailsData && modelDetailsData.approvedDTO) {
        this.modelStatus = modelDetailsData.approvedDTO.status;
        this.ies.getSecurityModelHistory(this.data.securityModelId, 'view').subscribe((historyData: any) => {
          this.historyData = historyData;
        });

        this.load(modelDetailsData.approvedDTO as IModelDetailsResponse);
        this.editorModelService.triggerRefreshData();
        this.cdr.detectChanges();
      }
    });
  }

  onCreateRebalance() {
    this.ats.trackClickEvent("lc_editsecrebal");

    const crConfig: any = {
      parentComponent: 'editor-model',
      parentComponentThis: this,
      modelId: this.data.securityModelId,
        modelName: this.data.securityModelName,
      closeParentBeforeNavigate: true
    };

    if (this.modelRalations) {
      crConfig.hasValidPortfolioRelationToModel = this.modelRalations.hasValidPortfolioRelation;
      crConfig.allowRebalanceSubmit = this.modelRalations.hasValidPortfolioRelation;
      this.as.fireEvent('createRebalance', crConfig);
    } else {
        const modelDetail: any = {
        modelId: this.data.securityModelId,
            modelName: this.data.securityModelName,
        type: 'Base',
      };
      this.ies.getModelAssociationDetails(modelDetail).subscribe((res: any) => {
        this.modelRalations = res;
        crConfig.hasValidPortfolioRelationToModel = this.modelRalations.hasValidPortfolioRelation;
        crConfig.allowRebalanceSubmit = this.modelRalations.hasValidPortfolioRelation;
        this.as.fireEvent('createRebalance', crConfig);
      });
    }
  }

  // displayTutorial() {
  //     console.log('Edit security model video - SECURITY_MODEL_TUT');
  //     // window.open('/irebal/resources/tutorials/index.jsp?#lesson3m_id30', '_blank');
  // }

  validMinMaxTarget() {
    if (!this.editorModelService.targetMinMaxChanged) {
      return true;
    }
    let targetPercentage, toleranceMinPercentage, toleranceMaxPercentage, i;
    const secList = this.data.securityModelAllocationList;
    let isValidationPassed = true;
    for (i = 0; i < secList.length; i++) {
      if (!secList[i].useGlobalValue) {
        targetPercentage = Number(secList[i].targetPercentage);
        toleranceMinPercentage = Number(secList[i].toleranceMinPercentage);
        toleranceMaxPercentage = Number(secList[i].toleranceMaxPercentage);

        if (toleranceMinPercentage > targetPercentage) {
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'error',
            summary: 'Invalid Min %',
            detail: 'Min % must be less than or equal to Target % for all securities.'
          });

          isValidationPassed = false;
          break;
        }

        if (toleranceMaxPercentage < targetPercentage) {
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'error',
            summary: 'Invalid Max %',
            detail: 'Max % must be greater than or equal to Target % for all securities.'
          });

          isValidationPassed = false;
          break;
        }
      }
    }
    return isValidationPassed;
  }

  actionStatusCheckIntervalStart(statusId: any) {
    this.ies.actionStatusCheckModel(statusId).subscribe((statusResponse: any) => {
      if (statusResponse.responseStatus === "SUCCESS") {

        let reqStatus = 'FAILED';
        if (statusResponse.responseUtilityMap && statusResponse.responseUtilityMap.requestStatus) {
          reqStatus = statusResponse.responseUtilityMap.requestStatus.trim().toUpperCase();
        }

        if (reqStatus === 'STARTED' || reqStatus === 'NEW' || reqStatus === 'IN_PROGRESS') {
          let timeout = (this.updateStatusCount > 10) ? 8000 : (this.updateStatusCount > 2) ? 3000 : 1500;
          if (this.isUiTest)
            timeout = 0;
          this.updateStatusCount++;
          this.progressTimer = setTimeout(() => {
            this.actionStatusCheckIntervalStart(statusId);
          }, timeout);
        }

        if (reqStatus === 'COMPLETED') {
          this.saveEditModelProceed(statusResponse);
          this.progressTimer && clearTimeout(this.progressTimer);
        }

        if (reqStatus === 'STALEDATAEXCEPTION') {
          this.as.fireEvent(IrbEditorsEvents.HIDE_WAIT, { "slot": this.slot });
          this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
            dTitle: 'Refresh Required',
            dProceedBtnLabel: 'Refresh',
            msg: "You are attempting to edit a model that was just modified by someone else. To see the updated model, you need to refresh the page.",
            onProceed: () => {this.refreshEditModel()}
          } as IAlertDialogData);
        }

        if (reqStatus === 'FAILED') {
          this.actionStatusCheckFailed();
        }
      } else {
        this.actionStatusCheckFailed();
      }
    }, () => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      this.progressTimer && clearTimeout(this.progressTimer);
    });
  }

  actionStatusCheckFailed() {
    this.as.fireEvent(IrbEditorsEvents.HIDE_WAIT, { "slot": this.slot });
    this.progressTimer && clearTimeout(this.progressTimer);
    this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
      severity: 'error',
      summary: "Save Edit Model",
      detail: " An error occurred processing your request."
    });
  }

  onCopyModel() {
    this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
      dTitle: 'Create a copy',
      dProceedBtnLabel: 'Yes',
      dCancelBtnLabel: "No",
      msg: "iRebal will create a copy of this model. Do you want to proceed?",
      onProceed: () => {this.copyModelProceed()}
    } as IAlertDialogData);
  }

  copyModelProceed() {
    const r = {} as ICreateModel;
    r.modelType = "Base";
    r.modelName = "Copy of " + this.data.securityModelName;
    r.modelDescription = this.data.securityDescription;

    this.modelEventData.isCopy = true;
    this.modelEventData.copyOnLoad = false;
    this.modelEventData.modelId = -1;
    this.data.parentModelId = this.data.securityModelId;
    this.data.securityModelId = -1;
    this.data.securityModelName = r.modelName;
    this.data.versionId = 0;
    this.data.createdDate = null;
    this.data.createdBy = null;
    this.data.modifiedDate = null;
    this.data.modifiedBy = null;
    this.historyData = [];
    this.onInputChange();
  }

  checkSecurityModelName(proceedCbFunc: Function, cancelCbFunc: Function) {
    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);

    this.ies.validateSecurityModelName(this.data.securityModelName, "Security").subscribe((data: any) => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);

      if (data.data === true) {
        cancelCbFunc();
        this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
          dType: 'ERROR',
          msg: 'Model name is already in use. Please provide another one.'
        });
      } else {
        proceedCbFunc();
      }
    });
  }
  openRebalanceGlobalSettings() {
    this.as.fireEvent(IrbSettingsEvents.SHOW, {defaultTabIndex: 7});
  }
  showPortfoliosByModel() {
    if (this.isModified) { return;}
    const state:IApplyFilterOnLanding = {
      isUpdatRequired : true,
      filterModel : {name:'securityModelName', value:[this.data.securityModelName], isUpdatRequired:true}
    } as IApplyFilterOnLanding;
    if (this.router.url === '/clients/portfolios') {
      this.router.navigateByUrl('/', { skipLocationChange: true}).then(() => {
        this.router.navigateByUrl('/clients/portfolios', { state: state });
      });
    } else {
      this.router.navigateByUrl('/clients/portfolios', { state: state });
    }
 }
 cancel() {
    if (this.modelEventData?.parentObj) {
      if (this.modelEventData?.parentObj?.reloadAfterModelClosed) {
        if (this.modelEventData?.parentObj?.multiplePortfolioEditRequest) {
          this.modelEventData.parentObj.closeAndReopen(this.modelEventData.parentObj.multiplePortfolioEditRequest);
        } else {
          if (this.modelEventData?.parentObj?.portfolioId) {
            this.modelEventData.parentObj.closeAndReopen(this.modelEventData.parentObj.portfolioId);
          }
        }
      }
    }
    super.cancel();
 }

  showSyntaxDialog() {
    this.ats.trackClickEvent("lc_syntax_sytx");
    this.as.fireEvent(IrbModelsEvents.SHOW_CREATE_SYNTAX_DIALOG);
  }
}
